<template>

  <div class="common-container">
    <div class="background"></div>
    <Header></Header>

    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
            <el-col :xs="22" :sm="22" :md="22" :lg="20" :xl="20">
              <el-row class="middle">
                <el-col class="middleRight">
                  <el-row type="flex" justify="center">
                    <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
                      <member-aside></member-aside>
                    </el-col>
                    <el-col :xs="0" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="member-detail-info-box">
                        <div class="member-detail-info-title">{{name}}</div>
                        <div class="member-detail-info-text" v-html="content"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>


    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        name: '',
        content: '',
      };
    },

    components: {},

    mounted() {
      this.getMemberDetail();
    },

    watch: {
      //监听相同路由下参数变化
      '$route'(to, from) {
        //每当参数变化时重新获取数据
        this.getMemberDetail();
      }
    },

    methods: {
      //获取成员详情
      getMemberDetail() {
        var id = this.$route.query.id;

        this.instance.get('/api/memberdetail', {
          params: {
            id: id
          }
        }).then(res => {
          this.name = res.data.name;
          this.content = res.data.content;
        })


      }
    },

  }
</script>
<style scoped>
  .member-detail-info-text>>>img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/MemberDetail.vue